import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import type { Workspace } from "~/workspaces/state/workspace";
import { getWorkspaces } from "~/workspaces/api/get-workspaces";

const getWorkspacesQueryOptions = queryOptions({
  queryKey: ["workspaces"],
  queryFn: getWorkspaces,
});

function useGetWorkspaces<TData = Workspace[]>(
  select?: (data: Workspace[]) => TData,
) {
  return useSuspenseQuery({
    ...getWorkspacesQueryOptions,
    select,
  });
}

export { useGetWorkspaces, getWorkspacesQueryOptions };
